# Našeptávač šarží v řádcích dokladu / objednávky (input.lot-autocomplete)
PRIJEMKY = [1, 3, 6, 7]

$(document).on 'focus', 'input.lot-autocomplete', ->
  input = $(this)
  return if input.data('ui-autocomplete')
  input.autocomplete
    minLength: 0
    source: (request, response) ->
      productId = input.closest('tr').find('input[id$=_product_id]').val()
      return response([]) unless productId
      # u příjemky nabízíme i vyprodané šarže, nová se dá napsat ručně
      all = if parseInt($('#document_document_type_id').val()) in PRIJEMKY then 1 else ''
      $.getJSON '/document_items/autocomplete_lot', { product_id: productId, term: request.term, all: all }, response
    # vybraná existující šarže předvyplní svou expiraci a pozici (řádek příjemky)
    select: (event, ui) ->
      row = input.closest('tr')
      row.find('input[id$=_expires_at]').val(ui.item.expires_at) if ui.item.expires_at
      row.find('select[id$=_position_id]').val(ui.item.position_id).trigger('change') if ui.item.position_id
  input.autocomplete('search', input.val())

# výběr pozice šarže nabízí pozice zvoleného skladu (na novém dokladu se sklad vybírá až ve formuláři)
lotPositionOptions = null

fillLotPositions = (selects) ->
  return unless lotPositionOptions?
  selects.each ->
    select = $(this)
    current = select.val()
    select.empty().append($('<option>', value: '', text: ''))
    select.append($('<option>', value: p.id, text: p.name)) for p in lotPositionOptions
    select.val(current)

$(document).on 'change', '#document_warehouse_id', ->
  warehouseId = $(this).val()
  return unless warehouseId && $('.lot-position-col').length # pozici šarže vybírá jen admin
  $.getJSON '/document_items/lot_positions', { warehouse_id: warehouseId }, (positions) ->
    lotPositionOptions = positions
    fillLotPositions($('select[id^=document_document_items][id$=_position_id]'))

$(document).on 'nested:fieldAdded', (event) ->
  fillLotPositions(event.field.find('select[id$=_position_id]'))

$(document).on 'turbolinks:load', -> lotPositionOptions = null

# šarže jde zadat jen u šaržovaných produktů
$(document).on 'railsAutocomplete.select', '[id$=_product_name]', (event, ui) ->
  fields = $(this).closest('tr').find('.lot-field, input.lot-autocomplete')
  return unless fields.length
  lots = ui.item && ui.item.lots
  fields.prop('disabled', !lots)
  fields.val('') unless lots
